import React from "react";
import { BusinessCreditReportStatePII } from "../../../../store/businessCreditReportService/types";
import { toggle } from "../../../../util/common";

interface IProps {
    reportObject: BusinessCreditReportStatePII;
    showAsAccordion?: boolean;
}
const LegalFilingsSummary: React.FunctionComponent<IProps> = (props) => {
    return (
        <React.Fragment>
            <div role="listitem" className="data-row">
                <div className="link-item">
                    {props.showAsAccordion ? (
                        <button
                            type="button"
                            aria-expanded="false"
                            className="link-button"
                            id="btn-leagal-filings-summary"
                            onClick={(e) => toggle("leagal-filings-summary-div", "btn-leagal-filings-summary")}
                        >
                            <span className="row link-item">
                                <span className="col-xs col-no-gutter link-text">
                                    <span className="link-title">
                                        <span className="btn-toggle-status sr-only">Show</span> Legal Filings Summary
                                    </span>
                                </span>
                            </span>
                        </button>
                    ) : (
                        <h5 className="report-sub-title">Legal Filings Summary</h5>
                    )}

                    <div
                        className="wallet-details"
                        id="leagal-filings-summary-div"
                        style={{ ...(props.showAsAccordion ? { display: "none" } : {}) }}
                        aria-hidden="true"
                    >
                        <div role="grid" className="data-grid row-height-xs " aria-labelledby="btn-leagal-filings-summary">
                            <div role="row" className="data-row condensed row">
                                <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="leagal-filings-summary-bankruptcy">
                                        Bankruptcy
                                    </div>
                                </div>
                                <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="leagal-filings-summary-judgements">
                                        Judgements
                                    </div>
                                </div>
                                <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="leagal-filings-summary-tax-lien-filing">
                                        Tax Lien Filing
                                    </div>
                                </div>
                            </div>

                            <div role="row" className="data-row condensed row">
                                <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                    <div className="data-value" aria-labelledby="leagal-filings-summary-bankruptcy">
                                        {props.reportObject?.businessCompanyReport?.legal_filings?.bankruptcy}
                                    </div>
                                </div>
                                <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                    <div className="data-value" aria-labelledby="leagal-filings-summary-judgements">
                                        {props.reportObject?.businessCompanyReport?.legal_filings?.judgements}
                                    </div>
                                </div>
                                <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                    <div className="data-value" aria-labelledby="leagal-filings-summary-tax-lien-filing">
                                        {props.reportObject?.businessCompanyReport?.legal_filings?.tax_lien_filing}
                                    </div>
                                </div>
                            </div>

                            <div role="row" className="data-row condensed row">
                                <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="leagal-filings-summary-ucc-filing">
                                        UCC Filing
                                    </div>
                                </div>
                                <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="leagal-filings-summary-cautionary-ucc-filing">
                                        Cautionary UCC Filing
                                    </div>
                                </div>
                                <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="leagal-filings-summary-blank"></div>
                                </div>
                            </div>

                            <div role="row" className="data-row condensed row">
                                <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                    <div className="data-value" aria-labelledby="leagal-filings-summary-ucc-filing">
                                        {props.reportObject?.businessCompanyReport?.legal_filings?.ucc_filing}
                                    </div>
                                </div>
                                <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                    <div className="data-value" aria-labelledby="leagal-filings-summary-cautionary-ucc-filing">
                                        {props.reportObject?.businessCompanyReport?.legal_filings?.cautionary_ucc_filing}
                                    </div>
                                </div>
                                <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                    <div className="data-value" aria-labelledby="leagal-filings-summary-blank"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default LegalFilingsSummary;
